export default {
  GET_ORGANIZATION: '/maindata/department/getDepartmentsUnderCurrentUserCompany',
};
